export enum MODAL {
  DETAILS = 'DETAILS',
  EDIT = 'EDIT',
}
